import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";

export const useSuperadmin = () => {
  const { features } = useAuthenticatedUser();
  return features.includes("superadmin");
};
